import React, { Component, createRef } from 'react';

export default class Slido extends Component {
    constructor() {
        super();
        this.state = {
            height: "610px"
        };
        this.containerRef = createRef();
        this.quizId = null;
        this.componentContent = null;
    }

    componentRealContent() {
        const quizURL=`${this.quizId}`;
        //
        return (
            <iframe src={quizURL} style={{transitionProperty: "all", transitionDuration: "1.5s"}} frameBorder={"0"} title={"Slido"} height={this.state.height} width={"100%"}>
            </iframe>
        )
    }

    adjustComponentHeight() {
        this.componentContent = this.componentRealContent();

        // let height = document.getElementById('video-frame').clientHeight - 16; // 23 - padding
        const videoFrame = document.getElementById('video-frame');
        let height = videoFrame ? videoFrame.clientHeight - 16 : 0;
        height = height < this.minHeight ? this.minHeight : height;

        this.setState({height: height+"px"});
    }

    render() {
        const { quizId, isEnabled } = this.props;

        if (!quizId || isEnabled !== '1') {
            return null;
        }

        this.quizId = quizId;
        const quizURL = `${this.quizId}`;

        return (
            <div ref={this.containerRef} style={{ height: '100%', overflow: 'auto' }}>
                <iframe
                    src={quizURL}
                    title="Slido"
                    width="100%"
                    height="100%"
                    scrolling="yes"
                    style={{
                        transitionProperty: "all",
                        transitionDuration: "1.5s",
                        border: 0,
                        display: 'block'
                    }}
                />
            </div>
        );
    }
}
